import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.fabbench.auto.evaluation');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-fabbench-auto-evaluation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.fabbench.auto.evaluation/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.all-evaluation-page {
  background: radial-gradient(circle at 8% 0, rgba(139, 92, 246, 0.08), transparent 24rem), #f8fafc;
}

table {
  border-collapse: collapse;
}`],
})
export class PageFabbenchAutoEvaluationComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public metrics: any[] = [
        { key: 'factuality', label: 'Factuality', description: '사실 정확성' },
        { key: 'completeness', label: 'Completeness', description: '핵심 내용 충실도' },
        { key: 'technical_depth', label: 'Technical Depth', description: '기술적 깊이' },
        { key: 'relevance', label: 'Relevance', description: '질문 관련성' },
        { key: 'context_utilization', label: 'Context Utilization', description: 'gold context 활용도' },
        { key: 'support_quality', label: 'Support Quality', description: '근거와 예시 품질' }
    ];
    public categoryOptions: any[] = [
        { value: 'ALL', label: '전체 카테고리' },
        { value: 'ROB', label: 'ROB' },
        { value: 'MULTI', label: 'MULTI' },
        { value: 'GEN', label: 'GEN' }
    ];
    public formatOptions: any[] = [
        { value: 'ALL', label: '전체 형식' },
        { value: 'OBJECTIVE', label: 'OBJECTIVE' },
        { value: 'SUBJECTIVE', label: 'SUBJECTIVE' }
    ];
    public statusOptions: any[] = [
        { value: 'ALL', label: '전체 상태' },
        { value: 'SCORED', label: '채점 완료' },
        { value: 'ERROR', label: '오류' }
    ];

    public benchmark: any = {
        available: false,
        total_items: 0,
        format_counts: { OBJECTIVE: 0, SUBJECTIVE: 0 },
        category_counts: { ROB: 0, MULTI: 0, GEN: 0 },
        score_max: 10,
        normalization_divisor: 10,
        openai_judge: {
            model: 'gpt-4.1-mini-2025-04-14',
            api_key_configured: false,
            temperature: 0,
            structured_output: true,
            stream: false,
            store: false
        }
    };
    public generatorModels: any[] = [];
    public selectedGeneratorModel: string = '';
    public cases: any[] = [];
    public results: any[] = [];
    public summary: any = this.emptySummary();
    public selectedCategory: string = 'ALL';
    public selectedFormat: string = 'ALL';
    public selectedStatus: string = 'ALL';
    public selectedResult: any = null;
    public loading: boolean = true;
    public running: boolean = false;
    public cancelRequested: boolean = false;
    public activeCase: any = null;
    public activeIndex: number = 0;
    public runId: string = '';
    public startedAt: string = '';
    public completedAt: string = '';
    public error: string = '';
    public notice: string = '';
    public savedFiles: any[] = [];
    public saveRunning: boolean = false;
    public preparing: boolean = false;
    public paused: boolean = false;
    public pauseReason: string = '';
    public runGeneratorModel: string = '';
    public resumedFromRunId: string = '';
    public storageWarning: string = '';
    public resultsDirty: boolean = false;
    private destroyed: boolean = false;
    private draftKey: string = '';

    public historyRuns: any[] = [];
    public historyLoading: boolean = false;
    public historyError: string = '';
    public selectedHistoryRunId: string = '';
    public loadedHistory: any = null;

    public async ngOnInit() {
        this.preparing = true;
        try {
            await this.service.init();
            await this.loadBenchmark();
            await this.restoreDraft();
            await this.loadHistory();
        } finally {
            this.preparing = false;
            await this.service.render();
        }
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.cancelRequested = true;
    }

    public async loadBenchmark() {
        this.loading = true;
        this.error = '';
        await this.service.render();
        try {
            const response: any = await wiz.call('benchmark');
            if (!response || response.code !== 200) {
                this.error = this.errorMessage(
                    response,
                    'FAB-Bench 전체 문항을 불러오지 못했습니다.'
                );
                return;
            }
            this.benchmark = response.data.benchmark || this.benchmark;
            this.cases = response.data.cases || [];
            this.generatorModels = (this.benchmark.generator_models || []).filter(
                (model: any) => model && model.available
            );
            const selectedExists = this.generatorModels.some(
                (model: any) => model.name === this.selectedGeneratorModel
            );
            if (!selectedExists) {
                this.selectedGeneratorModel = (
                    this.generatorModels[0] || {}
                ).name || '';
            }
        } catch (error) {
            this.error = 'FAB-Bench 전체 문항을 불러오는 중 네트워크 오류가 발생했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async startEvaluation() {
        if (this.running || this.saveRunning || this.preparing || this.loading) return;
        if (!this.validateEvaluation(this.selectedGeneratorModel)) {
            await this.service.render();
            return;
        }
        this.preparing = true;
        try {
            if (!await this.saveBeforeSwitch()) return;
            this.results = [];
            this.summary = this.emptySummary();
            this.selectedResult = null;
            this.runId = this.newRunId();
            this.runGeneratorModel = this.selectedGeneratorModel;
            this.resumedFromRunId = '';
            this.startedAt = new Date().toISOString();
            this.resultsDirty = false;
            await this.runEvaluation();
        } finally {
            this.preparing = false;
            await this.service.render();
        }
    }

    private validateEvaluation(model: string) {
        this.error = '';
        if (!model) {
            this.error = '답변 생성 모델을 선택해주세요.';
        } else if (!this.generatorModels.some((item: any) => item.name === model)) {
            this.error = '이 평가에 사용한 생성 모델이 현재 설치되어 있지 않습니다. 모델 상태를 확인해주세요.';
        } else if (!this.benchmark.openai_judge?.api_key_configured) {
            this.error = '서버의 OPENAI_API_KEY 설정을 확인해주세요.';
        } else if (!this.cases.length) {
            this.error = '평가할 FAB-Bench 문항이 없습니다.';
        }
        return !this.error;
    }

    public pendingCases(rows: any[] = this.results) {
        const scored = new Set(rows.filter((row: any) => row.status === 'SCORED')
            .map((row: any) => this.trackResult(0, row)));
        return this.cases.filter((item: any) => !scored.has(this.trackResult(0, item)));
    }

    public async resumeEvaluation() {
        if (this.running || this.saveRunning || this.preparing || this.loading || !this.runId) return;
        if (!this.pendingCases().length || !this.validateEvaluation(this.runGeneratorModel)) {
            await this.service.render();
            return;
        }
        this.preparing = true;
        try {
            this.selectedGeneratorModel = this.runGeneratorModel;
            await this.runEvaluation();
        } finally {
            this.preparing = false;
            await this.service.render();
        }
    }

    private async runEvaluation() {
        this.error = '';
        this.notice = '';
        this.savedFiles = [];
        this.paused = false;
        this.pauseReason = '';
        this.completedAt = '';
        this.running = true;
        this.cancelRequested = false;
        try {
            // Persist the run ID before starting a request, including the first one.
            // A reload can then reuse exactly the same server checkpoint token.
            await this.persistDraft();
            for (let index = 0; index < this.cases.length; index += 1) {
                if (this.cancelRequested) break;
                const item = this.cases[index];
                if (this.results.some((row: any) =>
                    this.trackResult(0, row) === this.trackResult(0, item) && row.status === 'SCORED')) continue;
                this.activeCase = item;
                this.activeIndex = index + 1;
                await this.service.render();
                const result = await this.evaluateCase(item, index);
                if (this.destroyed) break;
                this.replaceResult(result);
                if (result.status !== 'SCORED') {
                    this.pauseReason = item.test_id + ' · ' + this.statusLabel(result.status) + ': ' + result.error;
                }
                await this.persistDraft();
                await this.service.render();
                if (result.status !== 'SCORED') break;
            }
        } catch (error) {
            this.pauseReason = this.errorMessage(error, '평가 진행 중 오류가 발생했습니다.');
        } finally {
            this.running = false;
            this.activeCase = null;
            // The draft saved before the request is enough to replay it later.
            // A detached component must not overwrite a new page's progress.
            if (this.destroyed) return;
            this.paused = this.pendingCases().length > 0;
            const cancelled = this.cancelRequested;
            this.cancelRequested = false;
            if (this.paused && !this.pauseReason) {
                this.pauseReason = cancelled ? '사용자가 평가를 일시중지했습니다.' : '남은 문항이 있습니다.';
            }
            this.completedAt = this.paused ? '' : new Date().toISOString();
            await this.persistDraft();
            const saved = this.results.length ? await this.saveBothFormats(true, cancelled) : false;
            this.notice = this.paused
                ? '평가를 일시중지했습니다. 이어서 평가를 누르면 오류·미실행 문항부터 재개합니다.'
                : '전체 GPT 평가를 완료했습니다.';
            if (saved) {
                this.notice += ' 현재 결과를 JSON과 CSV로 저장했습니다.';
                if (!this.paused) {
                    try { await this.clearDraft(); } catch (_) { /* A completed draft is safe to restore. */ }
                }
                await this.loadHistory();
            } else if (this.results.length) {
                this.notice += ' 서버 저장을 완료하지 못했습니다. 현재 결과 저장을 다시 눌러주세요.';
            }
            await this.service.render();
        }
    }

    private replaceResult(result: any) {
        const key = this.trackResult(0, result);
        const previous = this.results.findIndex((row: any) => this.trackResult(0, row) === key);
        if (previous < 0) this.results.push(result);
        else {
            const oldJudge = this.results[previous].metrics?.judge || {};
            const newJudge = result.metrics?.judge || {};
            // A failed Judge response can already have billable usage. Keep it
            // when a later attempt replaces the failed row, including another
            // transport failure. Replaying the same response must not add it twice.
            const sameResponse = oldJudge.response_id && oldJudge.response_id === newJudge.response_id;
            if (sameResponse) {
                result.metrics = { ...result.metrics, judge: { ...newJudge, ...oldJudge } };
            } else {
                const judge = { ...newJudge };
                for (const field of ['api_request_count', 'input_tokens', 'cached_input_tokens',
                    'output_tokens', 'total_tokens', 'estimated_cost_usd', 'total_duration_ms', 'attempts']) {
                    judge[field] = Number(oldJudge[field] || 0) + Number(newJudge[field] || 0);
                }
                judge.response_id = newJudge.response_id || oldJudge.response_id || '';
                result.metrics = { ...result.metrics, judge };
            }
            this.results[previous] = result;
        }
        this.resultsDirty = true;
        this.summary = this.summarize(this.results);
    }

    public requestCancel() {
        if (!this.running) return;
        this.cancelRequested = true;
        this.notice = '현재 요청이 끝나면 일시중지합니다. 완료된 문항은 재개할 때 유지됩니다.';
    }

    public async evaluateCase(item: any, index: number) {
        const previous = this.results.find((row: any) =>
            this.trackResult(0, row) === this.trackResult(0, item));
        const token = previous?.request_token || [
            this.runId, item.question_format, item.test_id, String(index)
        ].join(':');
        const params = {
            test_id: item.test_id,
            question_format: item.question_format,
            generator_model: this.runGeneratorModel || this.selectedGeneratorModel,
            request_token: token
        };
        const retryDelays = [2000, 5000];
        let failure: any = null;
        for (let attempt = 0; attempt <= retryDelays.length; attempt += 1) {
            let response: any;
            try {
                response = await wiz.call('evaluate', params);
                if (response?.code === 200 && response?.data?.result?.status) {
                    return { ...response.data.result, question_format: item.question_format, request_token: token };
                }
            } catch (error) {
                response = error;
            }
            const status = Number(response?.responseJSON?.code || response?.status || response?.code || 0);
            const message = this.errorMessage(response, '평가 API 응답을 받지 못했습니다.');
            failure = { ...this.errorResult(item, message), request_token: token };
            const retryable = !status || status === 200 || [408, 409, 425, 429].includes(status) || status >= 500;
            if (!retryable || this.cancelRequested || attempt === retryDelays.length) break;
            this.notice = item.test_id + ' 응답 확인 중 · ' + (attempt + 1) + '/2 자동 재시도';
            await this.service.render();
            await new Promise((resolve) => setTimeout(resolve, retryDelays[attempt]));
            if (this.cancelRequested) break;
        }
        return failure;
    }

    public async saveBothFormats(quiet: boolean = false, cancelled: boolean = false) {
        if (!this.results.length || this.saveRunning) return false;
        this.saveRunning = true;
        const saved: any[] = [];
        try {
            await this.service.render();
            for (const format of ['json', 'csv']) {
                const item = await this.saveFormat(format, cancelled);
                if (item) saved.push(item);
            }
            this.savedFiles = saved;
            if (saved.length === 2) this.resultsDirty = false;
            await this.persistDraft();
            if (!quiet) {
                this.notice = saved.length === 2
                    ? '현재 GPT 결과를 JSON과 CSV로 저장했습니다.'
                    : '서버 저장을 완료하지 못했습니다. 현재 결과를 유지하고 있으니 저장을 다시 시도해주세요.';
            }
        } finally {
            this.saveRunning = false;
            await this.service.render();
        }
        return saved.length === 2;
    }

    private async saveFormat(format: string, cancelled: boolean) {
        try {
            const response: any = await wiz.call('save', {
                format,
                results: JSON.stringify(this.results),
                metadata: JSON.stringify({
                    generator_model: this.runGeneratorModel || this.selectedGeneratorModel,
                    judge_model: this.openAIConfig().model,
                    started_at: this.startedAt,
                    completed_at: this.completedAt,
                    cancelled,
                    client_run_id: this.runId,
                    paused: this.paused,
                    pause_reason: this.pauseReason,
                    resumed_from_run_id: this.resumedFromRunId
                })
            });
            return response && response.code === 200 ? response.data.saved : null;
        } catch (error) {
            return null;
        }
    }

    public summarize(rows: any[]) {
        const summary: any = this.summarizeRows(rows);
        summary.by_category = {};
        for (const category of ['ROB', 'MULTI', 'GEN']) {
            summary.by_category[category] = this.summarizeRows(
                rows.filter((row: any) => row.category === category)
            );
        }
        summary.by_format = {};
        for (const questionFormat of ['OBJECTIVE', 'SUBJECTIVE']) {
            summary.by_format[questionFormat] = this.summarizeRows(
                rows.filter((row: any) => row.question_format === questionFormat)
            );
        }
        summary.openai_usage = this.openAIUsage(rows);
        return summary;
    }

    private summarizeRows(rows: any[]) {
        const scored = rows.filter((row: any) => row.status === 'SCORED');
        const metricAverages: any = {};
        const metricNormalized: any = {};
        for (const metric of this.metrics) {
            const values = scored
                .map((row: any) => Number((row.judge_scores || {})[metric.key]))
                .filter((value: number) => Number.isFinite(value));
            const average = values.length
                ? this.round(values.reduce((sum: number, value: number) => sum + value, 0) / values.length, 2)
                : 0;
            metricAverages[metric.key] = average;
            metricNormalized[metric.key] = this.round(average / 10, 4);
        }
        const overallValues = scored
            .map((row: any) => Number(row.average_score))
            .filter((value: number) => Number.isFinite(value));
        const overall = overallValues.length
            ? this.round(overallValues.reduce((sum: number, value: number) => sum + value, 0) / overallValues.length, 2)
            : 0;
        return {
            total: rows.length,
            scored: scored.length,
            errors: rows.length - scored.length,
            metric_averages: metricAverages,
            metric_averages_normalized: metricNormalized,
            overall_average: overall,
            overall_normalized: this.round(overall / 10, 4),
            overall_score_100: this.round(overall * 10, 2)
        };
    }

    public openAIUsage(rows: any[]) {
        const usage: any = {
            api_request_count: 0,
            input_tokens: 0,
            cached_input_tokens: 0,
            output_tokens: 0,
            total_tokens: 0,
            estimated_cost_usd: 0
        };
        for (const row of rows) {
            const judge = ((row.metrics || {}).judge || {});
            for (const key of [
                'api_request_count', 'input_tokens', 'cached_input_tokens',
                'output_tokens', 'total_tokens'
            ]) {
                usage[key] += Number(judge[key] || 0);
            }
            usage.estimated_cost_usd += Number(judge.estimated_cost_usd || 0);
        }
        usage.estimated_cost_usd = this.round(usage.estimated_cost_usd, 8);
        return usage;
    }

    public filteredResults() {
        return this.results.filter((row: any) => {
            if (this.selectedCategory !== 'ALL' && row.category !== this.selectedCategory) return false;
            if (this.selectedFormat !== 'ALL' && row.question_format !== this.selectedFormat) return false;
            if (this.selectedStatus === 'SCORED' && row.status !== 'SCORED') return false;
            if (this.selectedStatus === 'ERROR' && row.status === 'SCORED') return false;
            return true;
        });
    }

    public async loadHistory() {
        this.historyLoading = true;
        this.historyError = '';
        await this.service.render();
        try {
            const response: any = await wiz.call('history');
            if (response && response.code === 200) {
                this.historyRuns = response.data.runs || [];
            } else {
                this.historyError = this.errorMessage(response, 'GPT 평가 이력을 읽지 못했습니다.');
            }
        } catch (error) {
            this.historyError = 'GPT 평가 이력을 읽는 중 네트워크 오류가 발생했습니다.';
        } finally {
            this.historyLoading = false;
            await this.service.render();
        }
    }

    public async loadHistoryDetail(runId: string) {
        if (!runId || this.running || this.preparing || this.saveRunning) return;
        this.selectedHistoryRunId = runId;
        this.loadedHistory = null;
        this.historyError = '';
        await this.service.render();
        try {
            const response: any = await wiz.call('history_detail', { run_id: runId });
            if (response && response.code === 200) {
                this.loadedHistory = response.data.document;
            } else {
                this.historyError = this.errorMessage(response, '선택한 GPT 평가 이력을 불러오지 못했습니다.');
            }
        } catch (error) {
            this.historyError = '선택한 GPT 평가 이력을 불러오는 중 네트워크 오류가 발생했습니다.';
        }
        await this.service.render();
    }

    public downloadHistoryJson() {
        if (!this.loadedHistory) return;
        const blob = new Blob(
            [JSON.stringify(this.loadedHistory, null, 2)],
            { type: 'application/json;charset=utf-8' }
        );
        const anchor = document.createElement('a');
        anchor.href = URL.createObjectURL(blob);
        anchor.download = (this.loadedHistory.run_id || 'fab-bench-gpt-history') + '.json';
        anchor.click();
        URL.revokeObjectURL(anchor.href);
    }

    public historyRows() {
        if (!this.loadedHistory || !Array.isArray(this.loadedHistory.results)) return [];
        return this.loadedHistory.results.slice(0, 200);
    }

    public historyCanResume() {
        return this.loadedHistory?.run_kind === 'fab_bench_all_items_openai_judge'
            && this.pendingCases(this.historyRows()).length > 0;
    }

    public async resumeHistory() {
        if (this.running || this.saveRunning || this.preparing || this.loading || !this.historyCanResume()) return;
        const document = this.loadedHistory;
        const rows = document.results;
        const execution = document.execution || {};
        const model = execution.generator_model || rows[0]?.generator_model || '';
        const incompatibility = this.resumeCompatibility(rows, model, document.rubric_version, execution.judge_model);
        if (incompatibility || !this.validateEvaluation(model)) {
            this.historyError = incompatibility || this.error;
            await this.service.render();
            return;
        }
        this.preparing = true;
        try {
            if (!await this.saveBeforeSwitch()) return;
            this.results = JSON.parse(JSON.stringify(rows));
            this.summary = this.summarize(this.results);
            this.selectedResult = null;
            this.runId = this.validRunId(execution.client_run_id) ? execution.client_run_id : this.newRunId();
            this.runGeneratorModel = model;
            this.selectedGeneratorModel = model;
            this.startedAt = execution.started_at || new Date().toISOString();
            this.resumedFromRunId = document.run_id;
            this.resultsDirty = false;
            this.historyError = '';
            await this.runEvaluation();
        } finally {
            this.preparing = false;
            await this.service.render();
        }
    }

    private async saveBeforeSwitch() {
        if (!this.results.length || !this.resultsDirty) return true;
        if (await this.saveBothFormats(true)) return true;
        this.error = '현재 결과를 서버에 저장하지 못해 평가 전환을 중단했습니다. 저장을 다시 시도해주세요.';
        return false;
    }

    private validRunId(value: any) {
        return typeof value === 'string' && /^[A-Za-z0-9._:-]{1,120}$/.test(value);
    }

    private resumeCompatibility(rows: any, model: string, rubricVersion: string, judgeModel: string) {
        if (!Array.isArray(rows) || rows.length > 200) return '재개할 결과 형식이 올바르지 않습니다.';
        if (rubricVersion && this.benchmark.rubric_version && rubricVersion !== this.benchmark.rubric_version) {
            return '평가 기준이 변경되어 이 결과에 이어서 평가할 수 없습니다. 새 전체 평가를 시작해주세요.';
        }
        if (judgeModel && judgeModel !== this.openAIConfig().model) {
            return '기존 결과의 GPT 모델이 현재 설정과 달라 이어서 평가할 수 없습니다.';
        }
        const known = new Set(this.cases.map((item: any) => this.trackResult(0, item)));
        const seen = new Set<string>();
        for (const row of rows) {
            if (!row || !known.has(this.trackResult(0, row)) || seen.has(this.trackResult(0, row))) {
                return '현재 데이터셋과 일치하지 않거나 중복된 문항이 있어 재개할 수 없습니다.';
            }
            if (row.generator_model && row.generator_model !== model) {
                return '생성 모델이 혼합된 결과는 이어서 평가할 수 없습니다.';
            }
            if (row.request_token && !/^[A-Za-z0-9._:-]{1,200}$/.test(row.request_token)) {
                return '저장된 문항 요청 정보가 올바르지 않습니다.';
            }
            seen.add(this.trackResult(0, row));
        }
        return '';
    }

    private async persistDraft() {
        if (!this.runId || this.destroyed) return;
        try {
            await this.writeDraft({
                schema_version: 1,
                run_id: this.runId,
                generator_model: this.runGeneratorModel,
                rubric_version: this.benchmark.rubric_version || '',
                judge_model: this.openAIConfig().model,
                started_at: this.startedAt,
                completed_at: this.completedAt,
                results: this.results,
                paused: this.paused,
                pause_reason: this.pauseReason,
                resumed_from_run_id: this.resumedFromRunId,
                results_dirty: this.resultsDirty
            });
            this.storageWarning = '';
        } catch (_) {
            this.storageWarning = '브라우저 임시 저장에 실패했습니다. 서버 저장을 확인하기 전에는 이 탭을 닫지 마세요.';
        }
    }

    public async restoreDraft() {
        try {
            const draft = await this.readDraft();
            if (!draft) return;
            const incompatibility = this.resumeCompatibility(
                draft.results, draft.generator_model, draft.rubric_version, draft.judge_model
            );
            if (draft.schema_version !== 1 || !this.validRunId(draft.run_id) || !draft.generator_model || incompatibility) {
                this.storageWarning = incompatibility || '브라우저에 저장된 진행 상태를 복원하지 못했습니다. 이전 평가 결과를 확인해주세요.';
                return;
            }
            this.runId = draft.run_id;
            this.runGeneratorModel = draft.generator_model;
            this.selectedGeneratorModel = draft.generator_model;
            this.startedAt = draft.started_at;
            this.completedAt = draft.completed_at || '';
            this.results = draft.results;
            this.summary = this.summarize(this.results);
            this.resumedFromRunId = draft.resumed_from_run_id || '';
            this.resultsDirty = draft.results_dirty !== false;
            this.paused = this.pendingCases().length > 0;
            this.pauseReason = this.paused ? (draft.pause_reason || '이전 진행 상태를 복원했습니다.') : '';
            this.notice = this.paused
                ? '이전 진행 상태를 복원했습니다. 이어서 평가를 누르면 오류·미실행 문항부터 재개합니다.'
                : '브라우저에 보관된 완료 결과를 복원했습니다.';
        } catch (_) {
            this.storageWarning = '브라우저에 저장된 진행 상태를 읽지 못했습니다. 이전 평가 결과에서 재개할 수 있습니다.';
        }
        await this.service.render();
    }

    private readDraft() {
        return this.draftTransaction('readonly', (store: IDBObjectStore) => store.get(this.getDraftKey()));
    }

    private writeDraft(draft: any) {
        return this.draftTransaction('readwrite', (store: IDBObjectStore) => store.put(draft, this.getDraftKey()));
    }

    private clearDraft() {
        return this.draftTransaction('readwrite', (store: IDBObjectStore) => {
            const key = this.getDraftKey();
            const request = store.get(key);
            request.onsuccess = () => {
                if (request.result?.run_id === this.runId) store.delete(key);
            };
            return request;
        });
    }

    private getDraftKey() {
        if (!this.draftKey) {
            const storageKey = 'fab-bench-auto-evaluation-tab';
            let tab = sessionStorage.getItem(storageKey);
            if (!tab) {
                tab = this.newRunId();
                sessionStorage.setItem(storageKey, tab);
            }
            this.draftKey = 'tab:' + tab;
        }
        return this.draftKey;
    }

    private draftTransaction(mode: IDBTransactionMode, action: (store: IDBObjectStore) => IDBRequest) {
        return new Promise<any>((resolve, reject) => {
            const opening = indexedDB.open('fab-bench-auto-evaluation', 1);
            opening.onupgradeneeded = () => {
                if (!opening.result.objectStoreNames.contains('drafts')) opening.result.createObjectStore('drafts');
            };
            opening.onerror = () => reject(opening.error);
            opening.onblocked = () => reject(new Error('브라우저 저장소를 열지 못했습니다.'));
            opening.onsuccess = () => {
                const db = opening.result;
                db.onversionchange = () => db.close();
                try {
                    const transaction = db.transaction('drafts', mode);
                    const request = action(transaction.objectStore('drafts'));
                    transaction.oncomplete = () => { db.close(); resolve(request.result); };
                    transaction.onabort = () => { db.close(); reject(transaction.error); };
                    transaction.onerror = () => { db.close(); reject(transaction.error); };
                } catch (error) {
                    db.close();
                    reject(error);
                }
            };
        });
    }

    public historyMetricScore(metricKey: string) {
        const summaryValue = this.finiteNumber(
            this.loadedHistory?.summary?.metric_averages?.[metricKey]
        );
        if (summaryValue !== null) return summaryValue;
        const values = this.historyRows()
            .map((row: any) => this.resultMetricScore(row, metricKey))
            .filter((value: number | null) => value !== null) as number[];
        return values.length
            ? this.round(
                values.reduce((sum: number, value: number) => sum + value, 0)
                    / values.length,
                2
            )
            : null;
    }

    public historyMetricNormalized(metricKey: string) {
        const summaryValue = this.finiteNumber(
            this.loadedHistory?.summary?.metric_averages_normalized?.[metricKey]
        );
        if (summaryValue !== null) return summaryValue;
        const score = this.historyMetricScore(metricKey);
        return score === null
            ? null
            : this.round(score / this.historyNormalizationDivisor(), 4);
    }

    public resultMetricScore(row: any, metricKey: string) {
        return this.finiteNumber(row?.judge_scores?.[metricKey]);
    }

    public resultMetricNormalized(row: any, metricKey: string) {
        const stored = this.finiteNumber(
            row?.judge_scores_normalized?.[metricKey]
        );
        if (stored !== null) return stored;
        const score = this.resultMetricScore(row, metricKey);
        return score === null
            ? null
            : this.round(score / this.historyNormalizationDivisor(), 4);
    }

    public formatSummary(questionFormat: string) {
        return (this.summary.by_format || {})[questionFormat] || this.emptyRowSummary();
    }

    public categorySummary(category: string) {
        return (this.summary.by_category || {})[category] || this.emptyRowSummary();
    }

    public openAIConfig() {
        return this.benchmark.openai_judge || {
            model: 'gpt-4.1-mini-2025-04-14',
            api_key_configured: false
        };
    }

    public progressPercent() {
        return this.cases.length
            ? Math.min(100, Math.round((this.summary.scored / this.cases.length) * 100))
            : 0;
    }

    public generatorLabel(model: any) {
        if (!model) return '';
        const details = [model.label || model.name];
        if (model.parameter_size) details.push(model.parameter_size);
        if (model.quantization_level) details.push(model.quantization_level);
        return details.join(' · ');
    }

    public statusLabel(status: string) {
        const labels: any = {
            SCORED: '채점 완료',
            GENERATOR_API_ERROR: '생성 API 오류',
            GENERATOR_RESPONSE_ERROR: '생성 응답 오류',
            JUDGE_API_ERROR: 'GPT API 오류',
            JUDGE_JSON_ERROR: 'GPT JSON 오류',
            DATA_ERROR: '데이터 오류',
            API_ERROR: 'API 오류'
        };
        return labels[String(status || '').toUpperCase()] || status || '대기';
    }

    public statusClass(status: string) {
        return status === 'SCORED'
            ? 'bg-emerald-50 text-emerald-700'
            : 'bg-rose-50 text-rose-700';
    }

    public openResult(row: any) {
        this.selectedResult = row;
    }

    public closeResult() {
        this.selectedResult = null;
    }

    public trackResult(_index: number, row: any) {
        return [row.question_format, row.test_id].join(':');
    }

    public trackHistory(_index: number, row: any) {
        return row.run_id;
    }

    public formatNumber(value: any) {
        return Number(value || 0).toLocaleString('ko-KR');
    }

    public formatCost(value: any) {
        return '$' + Number(value || 0).toFixed(6);
    }

    public usageCards() {
        return [
            {
                label: 'OpenAI 호출',
                value: this.formatNumber(this.summary.openai_usage.api_request_count) + '회'
            },
            {
                label: '입력 토큰',
                value: this.formatNumber(this.summary.openai_usage.input_tokens)
            },
            {
                label: '캐시 토큰',
                value: this.formatNumber(this.summary.openai_usage.cached_input_tokens)
            },
            {
                label: '출력 토큰',
                value: this.formatNumber(this.summary.openai_usage.output_tokens)
            },
            {
                label: '전체 토큰',
                value: this.formatNumber(this.summary.openai_usage.total_tokens)
            },
            {
                label: '예상 비용',
                value: this.formatCost(this.summary.openai_usage.estimated_cost_usd)
            }
        ];
    }

    private errorResult(item: any, message: string) {
        return {
            test_id: item.test_id,
            test_type: item.test_type,
            question_type: item.question_type,
            question_format: item.question_format,
            category: item.category,
            question: item.question,
            generator_model: this.runGeneratorModel || this.selectedGeneratorModel,
            judge_model: this.openAIConfig().model,
            judge_provider: 'openai',
            judge_scores: {},
            judge_scores_normalized: {},
            judge_reasons: {},
            average_score: null,
            normalized_score: null,
            status: 'API_ERROR',
            error_stage: 'api',
            error: message,
            metrics: { generator: {}, judge: {} }
        };
    }

    private emptySummary() {
        const summary: any = this.emptyRowSummary();
        summary.by_category = {
            ROB: this.emptyRowSummary(),
            MULTI: this.emptyRowSummary(),
            GEN: this.emptyRowSummary()
        };
        summary.by_format = {
            OBJECTIVE: this.emptyRowSummary(),
            SUBJECTIVE: this.emptyRowSummary()
        };
        summary.openai_usage = this.openAIUsage([]);
        return summary;
    }

    private emptyRowSummary() {
        const metricAverages: any = {};
        const normalized: any = {};
        for (const metric of this.metrics || []) {
            metricAverages[metric.key] = 0;
            normalized[metric.key] = 0;
        }
        return {
            total: 0,
            scored: 0,
            errors: 0,
            metric_averages: metricAverages,
            metric_averages_normalized: normalized,
            overall_average: 0,
            overall_normalized: 0,
            overall_score_100: 0
        };
    }

    private newRunId() {
        return 'all-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }

    private errorMessage(response: any, fallback: string) {
        const detail = response?.responseJSON?.data?.message
            || response?.responseJSON?.message || response?.data?.message
            || response?.message || response?.statusText || fallback;
        const status = Number(response?.responseJSON?.code || response?.status || response?.code || 0);
        return String(detail).slice(0, 1000) + (status >= 400 ? ' (HTTP ' + status + ')' : '');
    }

    private historyNormalizationDivisor() {
        const value = this.finiteNumber(
            this.loadedHistory?.execution?.normalization_divisor
            ?? this.loadedHistory?.normalization_divisor
            ?? this.benchmark?.normalization_divisor
            ?? 10
        );
        return value !== null && value > 0 ? value : 10;
    }

    private finiteNumber(value: any): number | null {
        if (value === null || value === undefined || value === '') return null;
        const numeric = Number(value);
        return Number.isFinite(numeric) ? numeric : null;
    }

    private round(value: number, digits: number) {
        const scale = Math.pow(10, digits);
        return Math.round((value + Number.EPSILON) * scale) / scale;
    }
}

export default PageFabbenchAutoEvaluationComponent;